module.exports = __webpack_public_path__ + "img/w63.25a10394.svg";